module.exports = __webpack_public_path__ + "img/class_L2.cd321084.jpg";